import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import LegacyNotificationOverview from '../components/LegacyNotificationOverview';
import BreadCrumb from '../../shared/components/BreadCrumb';
import AddAlertIcon from '@material-ui/icons/AddAlert';
import { Typography, Button } from '@material-ui/core';

const LegacyOrganizationNotifications = (props: RouteComponentProps<any>) => {
  return (
    <div>
      <Typography
        color="textSecondary"
        gutterBottom={true}
      >
        <BreadCrumb value="Organization" to="/organization/settings" />
        Notifications
      </Typography>
      <div className="padding-bottom-15">
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => {
            props.history.push('/organization/notifications/add');
          }}
        >
          <AddAlertIcon className="margin-right-8" /> Add Notification
        </Button>
      </div>
      <LegacyNotificationOverview />
    </div>
  );
};

export default withRouter(LegacyOrganizationNotifications);



// WEBPACK FOOTER //
// ./src/modules/organization/pages/LegacyOrganizationNotifications.tsx